import { render, staticRenderFns } from "./ArticulosMobileComp.vue?vue&type=template&id=37a3d872&scoped=true&"
import script from "./ArticulosMobileComp.vue?vue&type=script&lang=js&"
export * from "./ArticulosMobileComp.vue?vue&type=script&lang=js&"
import style0 from "./ArticulosMobileComp.vue?vue&type=style&index=0&id=37a3d872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3d872",
  null
  
)

export default component.exports